module.exports = "data:image/gif;base64,R0lGODlhEAALANUAANjl+KTUGWSuZPb2KWKxVAArAGVq6fT0HajZVEWcRfz8Unu7e1OjU0N2+miwafz8SgBYABqDGl+rXwBEACaKJi9r97XiawASADuUOzly+TWSNfv7RKnA9TaKNna4doC+gEygTLnV96zG62+0b3a3O1uoW36f2Xd344+UszCQL83KpvjvNvnwOlyD6W1zqnOa+bDhQjeXFJ7SMTmkNK7dQ5XKc/bySa2sof3zUT+YQPXtRPTpHy1g9/z8WgBjAAAAACH5BAAAAAAALAAAAAAQAAsAAAaMQJ9QCClCJshJYen7OBcLj8XicAgkJUahacUqeopNIofRMC7NKwJ3ajQMK5kmBUIvCAqFCgAQZVwDAxQJFxA1eQ8tDS8cISYDBwckPxAeBA8bKBkNFRw3kTEdhSMMIDQsBjw8BjsBEREYPxMjIAkJMwM2OgcUrxEasl1ZDDQwY2QawEhLSxfOP9DRP0EAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/components/root/header/flags/br.gif
// module id = 782
// module chunks = 2